import { db } from '../config/firebase';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';

const COLLECTION = 'cauciones';

// Las precargas creadas por el cierre diario guardan monto/tasa/dias como string vacío,
// lo que rompe isValidCaucion al actualizar. Saneamos a número antes del soft delete.
const toNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Soft delete de una caución: marca estado 'Eliminada' y registra la autoría.
 * @param {{ id: string, monto?: any, tasa?: any, dias?: any }} caucion
 * @param {{ userId: string, userName: string }} actor
 */
export const softDeleteCaucion = (caucion, { userId, userName }) => {
  try {
    return updateDoc(doc(db, COLLECTION, caucion.id), {
      estado: 'Eliminada',
      eliminadoPorId: userId,
      eliminadoPorNombre: userName,
      eliminadoAt: serverTimestamp(),
      monto: toNumber(caucion.monto),
      tasa: toNumber(caucion.tasa),
      dias: toNumber(caucion.dias),
    });
  } catch (error) {
    console.error('caucionesService.softDeleteCaucion failed:', { id: caucion?.id, error });
    throw error;
  }
};
